import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Galerie } from './pages/Galerie';

/**
 * L'administration est chargée à la demande.
 *
 * Elle ne concerne qu'une personne, quelques fois par an ; l'embarquer dans le
 * paquet principal ferait payer son poids à chaque visiteur de la galerie.
 */
const EspaceAdmin = lazy(() =>
  import('./pages/EspaceAdmin').then((m) => ({ default: m.EspaceAdmin })),
);

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Galerie />} />
      <Route path="/r/:slug" element={<Galerie />} />
      {/* L'administration tient sur `/admin`, formulaire compris — l'adresse du
          site d'origine. `/connexion`, introduit puis retiré pendant la refonte,
          y renvoie plutôt que de tomber sur la galerie via la route fourre-tout. */}
      <Route path="/connexion" element={<Navigate to="/admin" replace />} />
      <Route
        path="/admin/*"
        element={
          <Suspense fallback={<p className="message">Chargement…</p>}>
            <EspaceAdmin />
          </Suspense>
        }
      />
      <Route path="*" element={<Galerie />} />
    </Routes>
  );
}
